const USER_CITY_KEY = 'user_city';

export function isLocalStorageAvailable(): boolean {
  try {
    if (typeof localStorage === 'undefined') return false;
    localStorage.setItem('feature_test', 'yes');
    if (localStorage.getItem('feature_test') !== 'yes') return false;
    localStorage.removeItem('feature_test');
    return true;
  } catch {
    return false;
  }
}

export function updateUserCity(city: string): void {
  if (!isLocalStorageAvailable()) return;
  localStorage.setItem(USER_CITY_KEY, city.toLocaleLowerCase());
}

export function getUserCity(): string | null {
  if (!isLocalStorageAvailable()) return null;
  return localStorage.getItem(USER_CITY_KEY);
}

export function readPropertyFromLocalStorage(key: string): string | null {
  if (!isLocalStorageAvailable()) return null;
  const value = localStorage.getItem(key);
  if (value === null || value === '') return null;
  return value;
}
